import { isDevelopment, isLocal } from 'utils/globals'

export enum SigninLayout {
  default = 'default',
  ecpf = 'ecpf',
}

const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1']

function isLocalHostname (): boolean {
  return LOCAL_HOSTNAMES.includes(window.location.hostname)
}

export const SigninModel = {
  chooseLayout: (): SigninLayout => {
    const hostname = window.location.hostname
    const validHostNames = ['localhost', 'hml.ecp.rodobens.agxsoftware.com', 'consignado.rodobens.com.br']

    if (validHostNames.includes(hostname)) {
      return SigninLayout.ecpf
    }

    return SigninLayout.default
  },

  canSwitchLayouts (secretCount: number): boolean {
    if (isLocal) return true
    if (isDevelopment && secretCount > 15) return true
    if (isLocalHostname() && secretCount > 15) return true
    return false
  }
}
